export const odmienionyPelnomocnik = (zamawiajacy) => {
  if (zamawiajacy === 'Ewa Szcześniewska - Pełnomocnik') {
    return 'Ewą Szcześniewską';
  }
}


// WEBPACK FOOTER //
// ./src/helpers.js